import { render, staticRenderFns } from "./consume-detail-dialog.vue?vue&type=template&id=5b6a731e&scoped=true&"
import script from "./consume-detail-dialog.vue?vue&type=script&lang=ts&"
export * from "./consume-detail-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./consume-detail-dialog.vue?vue&type=style&index=0&id=5b6a731e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a731e",
  null
  
)

export default component.exports